const cookies = {
  session: null,
  user: { credits: 0 },
  identity: null,
  inference_count: 0,
};

export default cookies;
